// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-application .base-button.v-btn.v-size--default{padding-left:16px;padding-right:16px}.v-application .base-button__text{font-size:16px;font-style:normal;font-weight:600;letter-spacing:-.067px;line-height:135%;text-transform:none}.v-application .base-button__text:first-letter{text-transform:uppercase}.v-application .base-button__text_small{font-size:14px;font-weight:600;letter-spacing:-.037px;line-height:140%}.v-application .base-button.base-button_default{background-color:#f3f6fa;color:#111}.v-application .base-button.base-button_default.base-button_outlined{background-color:transparent;border:thin solid #111;color:#111}.v-application .base-button.base-button_default.base-button_text{background-color:transparent;border:none;color:#111}.v-application .base-button.base-button_white{background-color:#fff;color:#1a5dd0}.v-application .base-button.base-button_primary{background-color:#1a5dd0;color:#fff}.v-application .base-button.base-button_primary.base-button_outlined{background-color:transparent;border:thin solid #1a5dd0;color:#1a5dd0}.v-application .base-button.base-button_primary.base-button_text{background-color:transparent;border:none;color:#1a5dd0}.v-application .base-button.base-button_secondary{background-color:#ecf1fb;color:#1a5dd0}.v-application .base-button.base-button_red{background-color:#ff4a37;color:#fff}.v-application .base-button.base-button_red.base-button_outlined{background-color:transparent;border:thin solid #ff4a37;color:#ff4a37}.v-application .base-button.base-button_red.base-button_text{background-color:transparent;border:none;color:#ff4a37}.v-application .base-button.base-button_vk{background-color:#07f;color:#fff}.v-application .base-button.base-button_small{padding-left:12px;padding-right:12px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary": "#1a5dd0",
	"secondary": "#ff4a37",
	"info": "#1a5dd0",
	"success": "#1eb37c",
	"error": "#ff4a37",
	"warning": "#ffa928",
	"anchor": "#1a5dd0",
	"ui-kit-brand": "#3981f1",
	"ui-kit-illustration": "#3981f1",
	"ui-kit-special": "#904fe2",
	"ui-kit-rating": "#ffa928",
	"ui-kit-button-text-snackbars": "#76cbff",
	"ui-kit-text": "#111",
	"ui-kit-text-secondary": "#424b58",
	"ui-kit-text-info": "#607a93",
	"ui-kit-text-success": "#00815a",
	"ui-kit-text-error": "#f52a14",
	"ui-kit-text-warning": "#df5000",
	"ui-kit-disabled": "#8da2ba",
	"ui-kit-icon-primary": "#111",
	"ui-kit-icon-secondary": "#607a93",
	"ui-kit-bg-primary": "#ecf1fb",
	"ui-kit-bg-secondary": "#f6f9ff",
	"ui-kit-bg-special": "#f0e4f5",
	"ui-kit-bg-success": "#e0f6ee",
	"ui-kit-bg-error": "#fce8e8",
	"ui-kit-bg-warning": "#fff2d9",
	"ui-kit-bg-club": "#ffeee5",
	"ui-kit-bg-gray-80": "#8da2ba",
	"ui-kit-bg-gray-60": "#c7d1df",
	"ui-kit-bg-gray-40": "#f3f6fa",
	"ui-kit-bg-gray-0": "#fff",
	"ui-kit-shadow": "rgba(14,39,77,.129)"
};
module.exports = ___CSS_LOADER_EXPORT___;
